import { Typography } from "@mui/material"
import Button from "@mui/material/Button"
import Stack from "@mui/material/Stack"
import Alert from "@mui/material/Alert"

import { useState } from "react"
import { useUserAuth } from "../../firebase/UserAuthContext"

const Login = () => {
	const [error, setError] = useState("")
	const { googleSignIn, user } = useUserAuth()

	const handleGoogleSignIn = async (e) => {
		e.preventDefault()
		try {
			await googleSignIn()
			//navigate("/")
		} catch (error) {
			alert("Error while login in. Details:\n", error.message)
			setError(error)
		}
	}

	return (
		<div>
			{error && <Alert severity="error">{error}</Alert>}
			{!user && (
				<Stack spacing={2} padding={10}>
					{/* <h2 className="mb-3">Firebase Auth Login</h2> */}

					<Typography variant="h2">Bienvenidos a UWH Madrid Club</Typography>
					<Typography variant="p">
						Accede a tu perfil pulsando el boton "Sign In"
					</Typography>
					<Button variant="contained" onClick={handleGoogleSignIn}>
						Sign In
					</Button>
				</Stack>
			)}
		</div>
	)
}

export default Login
